/**
 * Display-only currency helpers.
 * Wompi settlement stays COP; these rates are approximate for UX by locale.
 */

export const DISPLAY_CURRENCIES = [
  { code: 'COP', locale: 'es-CO', fromCop: 1, digits: 0 },
  { code: 'USD', locale: 'en-US', fromCop: 4000, digits: 0 },
  { code: 'EUR', locale: 'fr-FR', fromCop: 4300, digits: 0 },
  { code: 'GBP', locale: 'en-GB', fromCop: 5000, digits: 0 },
  { code: 'BRL', locale: 'pt-BR', fromCop: 720, digits: 0 },
  { code: 'MXN', locale: 'es-MX', fromCop: 200, digits: 0 },
  { code: 'RUB', locale: 'ru-RU', fromCop: 45, digits: 0 },
  { code: 'CNY', locale: 'zh-CN', fromCop: 560, digits: 0 },
  { code: 'JPY', locale: 'ja-JP', fromCop: 27, digits: 0 },
  { code: 'KRW', locale: 'ko-KR', fromCop: 2.9, digits: 0 },
  { code: 'INR', locale: 'hi-IN', fromCop: 48, digits: 0 },
  { code: 'AED', locale: 'ar-AE', fromCop: 1090, digits: 0 },
];

const LOCALE_CURRENCY = {
  es: 'COP',
  en: 'USD',
  pt: 'BRL',
  fr: 'EUR',
  de: 'EUR',
  nl: 'EUR',
  ru: 'RUB',
  zh: 'CNY',
  ja: 'JPY',
  ko: 'KRW',
  ar: 'AED',
  hi: 'INR',
};

export function currencyForLocale(appLocale) {
  const code = LOCALE_CURRENCY[String(appLocale || 'es').slice(0, 2)] || 'COP';
  return DISPLAY_CURRENCIES.find((c) => c.code === code) || DISPLAY_CURRENCIES[0];
}

export function getDisplayCurrency(code) {
  return DISPLAY_CURRENCIES.find((c) => c.code === code) || DISPLAY_CURRENCIES[0];
}

/** Convert a COP list price into a display amount for the selected currency. */
export function convertFromCop(priceCop, currencyCode = 'COP') {
  const meta = getDisplayCurrency(currencyCode);
  const raw = Number(priceCop) || 0;
  if (!meta.fromCop || meta.fromCop === 1) return Math.round(raw);
  return Math.round(raw / meta.fromCop);
}

export function formatDisplayAmount(priceCop, currencyCode = 'COP') {
  const meta = getDisplayCurrency(currencyCode);
  const amount = convertFromCop(priceCop, currencyCode);
  return new Intl.NumberFormat(meta.locale, {
    style: 'currency',
    currency: meta.code,
    maximumFractionDigits: meta.digits,
  }).format(amount);
}
